import { useEffect, useState, useRef } from 'react'
import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import * as am5plugins_exporting from '@amcharts/amcharts5/plugins/exporting'
import { Box, Typography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { loadStateFromLocalStorage } from '../../redux/utilsLocalStorage'
import moment from 'moment-timezone'
import { formatMinutesAsTime } from '../../utils/time'

// ENABLE / DISABLE vertical lines
// let labelButtonEnable = am5.Label.new(root, {
//   text: 'Enable vertical lines',
//   fontSize: 12,
//   fontWeight: '200',
//   fill: 'black',
// })

// let labelButtonDisable = am5.Label.new(root, {
//   text: 'Disable vertical lines',
//   fontSize: 12,
//   fontWeight: '200',
//   fill: 'black',
// })

// let verticalLinesButton = chart.plotContainer.children.push(
//   am5.Button.new(root, {
//     dx: 10,
//     dy: 10,
//     layer: 40,
//     label: labelButtonEnable,
//   }),
// )
// verticalLinesButton.get('background').setAll({
//   cornerRadiusTL: 5,
//   cornerRadiusTR: 5,
//   cornerRadiusBR: 5,
//   cornerRadiusBL: 5,
//   fill: am5.color(0x000000),
//   fillOpacity: 0.2,
// })
// let isToggled = false
// verticalLinesButton.events.on('click', function (ev) {
//   isToggled = !isToggled

//   if (isToggled) {
//     xAxis.get('renderer').grid.template.setAll({
//       strokeOpacity: 1,
//       strokeWidth: 1,
//       strokeDasharray: [10, 5, 2, 5],
//     })
//     verticalLinesButton.children.clear()
//     verticalLinesButton.children.push(labelButtonDisable)
//   } else {
//     xAxis.get('renderer').grid.template.setAll({
//       strokeOpacity: 0,
//     })
//     verticalLinesButton.children.clear()
//     verticalLinesButton.children.push(labelButtonEnable)
//   }
// })

const TIMESTAMP = 'Timestamp' // that should not change in future

const hideOnBeggining = [
  'ECMWF P10',
  'ECMWF P20',
  'ECMWF P50',
  'ECMWF P75',
  'ECMWF P90',
  'ETAEC P10',
  'ETAEC P25',
  'ETAEC P50',
  'ETAEC P75',
  'ETAEC P90',
  'GFS ETA P10',
  'GFS ETA P25',
  'GFS ETA P50',
  'GFS ETA P75',
  'GFS ETA P90',
  'ICON P10',
  'ICON P25',
  'ICON P50',
  'ICON P75',
  'ICON P90',
  'UKMO P10',
  'UKMO P25',
  'UKMO P50',
  'UKMO P75',
  'UKMO P90',
  'UKMO100 P10',
  'UKMO100 P25',
  'UKMO100 P50',
  'UKMO100 P75',
  'UKMO100 P90',
  'ICON EU P10',
  'ICON EU P25',
  'ICON EU P50',
  'ICON EU P75',
  'ICON EU P90',
  'KNMI EU P10',
  'KNMI EU P25',
  'KNMI EU P50',
  'KNMI EU P75',
  'KNMI EU P90',
  'MET NORDIC P10',
  'MET NORDIC P25',
  'MET NORDIC P50',
  'MET NORDIC P75',
  'MET NORDIC P90',
  'AIFS P10',
  'AIFS P25',
  'AIFS P50',
  'AIFS P75',
  'AIFS P90',
  'AROME FR HD P10',
  'AROME FR HD P25',
  'AROME FR HD P50',
  'AROME FR HD P75',
  'AROME FR HD P90',
  'ARPEGE EU P10',
  'ARPEGE EU P25',
  'ARPEGE EU P50',
  'ARPEGE EU P75',
  'ARPEGE EU P90',
  'DMI P10',
  'DMI P25',
  'DMI P50',
  'DMI P75',
  'DMI P90',
  'GEM P10',
  'GEM P25',
  'GEM P50',
  'GEM P75',
  'GEM P90',
  'ICON D2 P10',
  'ICON D2 P25',
  'ICON D2 P50',
  'ICON D2 P75',
  'ICON D2 P90',
  'KNMI NL P10',
  'KNMI NL P25',
  'KNMI NL P50',
  'KNMI NL P75',
  'KNMI NL P90',
  'Icing ml event',
  'Icing ml loss percent',
  'Icing ml power loss',
  'Icing ml probability',
  'Icing physical alarm',
  'Icing physical loss percent',
  'Icing physical power loss',
  'Icing physical probability',
]

// labels for legend mapping
const legendLabels = {
  Forecast_10: 'Forecast P10',
  Forecast_25: 'Forecast P25',
  Forecast_50: 'Forecast P50',
  Forecast_75: 'Forecast P75',
  Forecast_90: 'Forecast P90',
  Combined_10: 'Combined P10',
  Combined_25: 'Combined P25',
  Combined_50: 'Combined P50',
  Combined_75: 'Combined P75',
  Combined_90: 'Combined P90',
  // Plus/minus need BOTH Uncertainty_flag (sign -> color) and Uncertainty_delta (|%| -> value);
  // with only one of them nothing is drawn in the main chart.
  Uncertainty_delta: 'Uncertainty delta', // %
  Uncertainty_flag_plus: 'ECMWF overestimation', // sig - splited from Uncertainty_flag
  Uncertainty_flag_minus: 'ECMWF underestimation', // sig - splited from Uncertainty_flag
  Icing_binary_50: 'Icing binary', // sig
  Icing_binary_physical_50: 'Icing binary physical 50', // sig
  Icing_power_loss_50: 'Icing power loss 50', // MW
  Icing_probability_50: 'Icing probability 50', // %
  Icing_ml_event: 'Icing ml event',
  Icing_ml_loss_percent: 'Icing ml loss percent',
  Icing_ml_power_loss_p50: 'Icing ml power loss',
  Icing_ml_probability: 'Icing ml probability',
  Icing_physical_alarm: 'Icing physical alarm',
  Icing_physical_loss_percent: 'Icing physical loss percent',
  Icing_physical_power_loss_p50: 'Icing physical power loss',
  Icing_physical_probability: 'Icing physical probability',
  Ecmwf_10: 'ECMWF P10',
  Ecmwf_25: 'ECMWF P25',
  Ecmwf_50: 'ECMWF P50',
  Ecmwf_75: 'ECMWF P75',
  Ecmwf_90: 'ECMWF P90',
  Etaec_10: 'ETAEC P10',
  Etaec_25: 'ETAEC P25',
  Etaec_50: 'ETAEC P50',
  Etaec_75: 'ETAEC P75',
  Etaec_90: 'ETAEC P90',
  Gfs_eta_10: 'GFS ETA P10',
  Gfs_eta_25: 'GFS ETA P25',
  Gfs_eta_50: 'GFS ETA P50',
  Gfs_eta_75: 'GFS ETA P75',
  Gfs_eta_90: 'GFS ETA P90',
  Icon_10: 'ICON P10',
  Icon_20: 'ICON P20',
  Icon_50: 'ICON P50',
  Icon_75: 'ICON P75',
  Icon_90: 'ICON P90',
  Ukmo_10: 'UKMO P10',
  Ukmo_25: 'UKMO P25',
  Ukmo_50: 'UKMO P50',
  Ukmo_75: 'UKMO P75',
  Ukmo_90: 'UKMO P90',
  Ukmo100_10: 'UKMO100 P10',
  Ukmo100_20: 'UKMO100 P20',
  Ukmo100_50: 'UKMO100 P50',
  Ukmo100_75: 'UKMO100 P75',
  Ukmo100_90: 'UKMO100 P90',
  Icon_eu_10: 'ICON EU P10',
  Icon_eu_25: 'ICON EU P25',
  Icon_eu_50: 'ICON EU P50',
  Icon_eu_75: 'ICON EU P75',
  Icon_eu_90: 'ICON EU P90',
  Knmi_eu_10: 'KNMI EU P10',
  Knmi_eu_25: 'KNMI EU P25',
  Knmi_eu_50: 'KNMI EU P50',
  Knmi_eu_75: 'KNMI EU P75',
  Knmi_eu_90: 'KNMI EU P90',
  Met_nordic_10: 'MET NORDIC P10',
  Met_nordic_25: 'MET NORDIC P25',
  Met_nordic_50: 'MET NORDIC P50',
  Met_nordic_75: 'MET NORDIC P75',
  Met_nordic_90: 'MET NORDIC P90',
  Aifs_10: 'AIFS P10',
  Aifs_25: 'AIFS P25',
  Aifs_50: 'AIFS P50',
  Aifs_75: 'AIFS P75',
  Aifs_90: 'AIFS P90',
  Arome_fr_hd_10: 'AROME FR HD P10',
  Arome_fr_hd_25: 'AROME FR HD P25',
  Arome_fr_hd_50: 'AROME FR HD P50',
  Arome_fr_hd_75: 'AROME FR HD P75',
  Arome_fr_hd_90: 'AROME FR HD P90',
  Arpege_eu_10: 'ARPEGE EU P10',
  Arpege_eu_25: 'ARPEGE EU P25',
  Arpege_eu_50: 'ARPEGE EU P50',
  Arpege_eu_75: 'ARPEGE EU P75',
  Arpege_eu_90: 'ARPEGE EU P90',
  Dmi_10: 'DMI P10',
  Dmi_25: 'DMI P25',
  Dmi_50: 'DMI P50',
  Dmi_75: 'DMI P75',
  Dmi_90: 'DMI P90',
  Gem_10: 'GEM P10',
  Gem_25: 'GEM P25',
  Gem_50: 'GEM P50',
  Gem_75: 'GEM P75',
  Gem_90: 'GEM P90',
  Icon_d2_10: 'ICON D2 P10',
  Icon_d2_25: 'ICON D2 P25',
  Icon_d2_50: 'ICON D2 P50',
  Icon_d2_75: 'ICON D2 P75',
  Icon_d2_90: 'ICON D2 P90',
  Knmi_nl_10: 'KNMI NL P10',
  Knmi_nl_25: 'KNMI NL P25',
  Knmi_nl_50: 'KNMI NL P50',
  Knmi_nl_75: 'KNMI NL P75',
  Knmi_nl_90: 'KNMI NL P90',
  Windspeed_50: 'Forecast Wind Speed',
  Windspeed_online: 'Wind Speed Online',
  Downregulation: 'Downregulation',
  Downregulation_final: 'Downregulation final',
  Ideal_power_forecast_50: 'Ideal power forecast 50',
  Theoretical_power_forecast_50: 'Theoretical power forecast 50',
}

const useStyles = makeStyles(theme => ({
  customSubtitle: {
    fontSize: 16,
    color: theme.palette.primary.main,
    textAlign: 'center',
    marginBottom: '30px',
  },
}))

const unitsConversion = (clientUnit, clientResolution, data) => {
  // default unit is kW
  const ratio = 60 / clientResolution // 60 --> 1 hour to minutes

  const convert = (
    item,
    multiplier,
    applyRatio,
    noRatio = [],
    noConvert = [],
  ) => {
    const newItem = { ...item }
    Object.keys(newItem).forEach(key => {
      if (key === TIMESTAMP) return
      if (newItem[key] === null) return
      if (newItem[key] === undefined) return
      if (newItem[key] === 0) return

      if (noConvert.includes(key)) return

      const useRatio = applyRatio && !noRatio.includes(key)

      newItem[key] = useRatio
        ? (newItem[key] / ratio) * multiplier
        : newItem[key] * multiplier
    })
    return newItem
  }

  const NO_CONVERT = [
    'Uncertainty_flag',
    'Uncertainty_delta',
    'Icing_binary_50',
    'Icing_binary_physical_50',
    'Icing_probability_50',
    'Windspeed_50',
    'Windspeed_online',
  ]

  if (clientUnit === 'kWh') {
    return data.map(item =>
      convert(item, 1, true, ['Availability', 'Capacity'], NO_CONVERT),
    )
  }
  if (clientUnit === 'MW') {
    return data.map(item => convert(item, 0.001, false, [], NO_CONVERT))
  }
  if (clientUnit === 'MWh') {
    return data.map(item =>
      convert(item, 0.001, true, ['Availability', 'Capacity'], NO_CONVERT),
    )
  }
  return data
}

const creatSBLineSeries = (root, sbxAxis, sbyAxis, valueYField, scrollbarX) => {
  const sbseries = scrollbarX.chart.series.push(
    am5xy.LineSeries.new(root, {
      xAxis: sbxAxis,
      yAxis: sbyAxis,
      connect: false,
      valueYField: valueYField,
      valueXField: TIMESTAMP,
    }),
  )
  sbseries.fills.template.setAll({
    visible: true,
    fillOpacity: 0.3,
  })

  return sbseries
}

const createSBSeriesFromData = (root, scrollbarX, data) => {
  const sbxAxis = scrollbarX.chart.xAxes.push(
    am5xy.DateAxis.new(root, {
      baseInterval: { timeUnit: 'hour', count: 1 },
      renderer: am5xy.AxisRendererX.new(root, {
        opposite: false,
        strokeOpacity: 0,
      }),
    }),
  )

  const sbyAxis = scrollbarX.chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {}),
    }),
  )

  const sbseries = []
  if (data.length !== 0) {
    const seriesNames = Object.keys(data[0])
    seriesNames.forEach(name => {
      // uncertainty is %/sign, meaningless on the shared power axis (and can go negative)
      if (name === 'Uncertainty_flag' || name === 'Uncertainty_delta') return
      if (name !== TIMESTAMP) {
        const valueYField = name
        const sbLineSeries = creatSBLineSeries(
          root,
          sbxAxis,
          sbyAxis,
          valueYField,
          scrollbarX,
        )
        sbLineSeries.data.setAll(data)
        sbseries.push(sbLineSeries)
      }
    })
  } else {
    console.error('Metrics data is empty.')
  }

  return sbseries
}

const createLineSeries = (
  root,
  xAxis,
  yAxis,
  seriesName,
  valueYField,
  yAxisSignal,
  yAxisPercent,
  yAxisWindspeed,
  unit,
) => {
  const formatNumberUnit = unit === 'MWh' || unit === 'MW' ? '#.#' : '#.'
  const initObj = {
    name: legendLabels[seriesName] || seriesName,
    xAxis: xAxis,
    yAxis: yAxis,
    locationX: 0,
    tooltipLocationX: 0,
    connect: false, // flag for null values - connection data on chart
    valueYField: valueYField,
    valueXField: TIMESTAMP,
    tooltip: am5.Tooltip.new(root, {
      pointerOrientation: 'horizontal',
      labelText: `[bold]{valueY.formatNumber('${formatNumberUnit}')}`,
    }),
  }

  let lineSeries = null
  if (seriesName === 'Online') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0x33ff00),
      stroke: am5.color(0x33ff00),
    })
  } else if (seriesName === 'Metering') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0x0000ff),
      stroke: am5.color(0x0000ff),
    })
  } else if (seriesName === 'Forecast_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xcc0000),
      stroke: am5.color(0xcc0000),
    })
  } else if (seriesName === 'Availability') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xff0000),
      stroke: am5.color(0xff0000),
    })
  } else if (seriesName === 'Curtailment') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xffa500),
      stroke: am5.color(0xffa500),
    })
  } else if (seriesName === 'Downregulation') {
    lineSeries = am5xy.StepLineSeries.new(root, {
      ...initObj,
      yAxis: yAxisSignal,
    })
    lineSeries.setAll({
      stroke: am5.color(0xa203ff),
      fill: am5.color(0xa203ff),
    })
    lineSeries.fills.template.setAll({
      fillOpacity: 0.1,
      visible: true,
    })
  } else if (seriesName === 'Downregulation_final') {
    lineSeries = am5xy.StepLineSeries.new(root, {
      ...initObj,
      yAxis: yAxisSignal,
    })
    lineSeries.setAll({
      stroke: am5.color(0xff006d),
      // fill color drives the tooltip/legend-marker color; the area band is
      // NOT drawn because fills.template is left disabled below
      fill: am5.color(0xff006d),
    })
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4],
    })
    // no fills.template → dashed outline only, so the overlap with Downregulation never darkens
  } else if (seriesName === 'Ecmwf_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0x01befe),
      stroke: am5.color(0x01befe),
    })
  } else if (seriesName === 'Etaec_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xffdd00),
      stroke: am5.color(0xffdd00),
    })
  } else if (seriesName === 'Gfs_eta_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xff7d00),
      stroke: am5.color(0xff7d00),
    })
  } else if (seriesName === 'Icon_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0x8f00ff),
      stroke: am5.color(0x8f00ff),
    })
  } else if (seriesName === 'Ukmo_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xff006d),
      stroke: am5.color(0xff006d),
    })
  } else if (seriesName === 'Ukmo100_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xadff02),
      stroke: am5.color(0xadff02),
    })
  } else if (seriesName === 'Uncertainty_flag_plus') {
    lineSeries = am5xy.StepLineSeries.new(root, {
      ...initObj,
      valueYField: 'Uncertainty_flag_plus',
      yAxis: yAxisPercent,
    })
    lineSeries.setAll({
      stroke: am5.color(0x368ed8),
      fill: am5.color(0x368ed8),
    })
    lineSeries
      .get('tooltip')
      .set('labelText', "[bold]{valueY.formatNumber('#.#')}%")
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4],
      strokeWidth: 2,
      stroke: am5.color(0x368ed8),
    })
    lineSeries.fills.template.setAll({
      fillOpacity: 0.3,
      visible: true,
      fill: am5.color(0x368ed8),
    })
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Uncertainty_flag_minus') {
    lineSeries = am5xy.StepLineSeries.new(root, {
      ...initObj,
      valueYField: 'Uncertainty_flag_minus',
      yAxis: yAxisPercent,
    })

    lineSeries.setAll({
      stroke: am5.color(0xff0000),
      fill: am5.color(0xff0000),
    })
    lineSeries.strokes.template.setAll({
      stroke: am5.color(0xff0000),
      strokeWidth: 2,
      strokeDasharray: [4, 4],
    })
    lineSeries.fills.template.setAll({
      fill: am5.color(0xff0000),
      fillOpacity: 0.3,
      visible: true,
    })

    lineSeries.set(
      'tooltip',
      am5.Tooltip.new(root, {
        pointerOrientation: 'horizontal',
        labelText: "[bold]{valueY.formatNumber('#.#')}%",
      }),
    )
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Uncertainty_delta') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      yAxis: yAxisPercent,
    })
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4], // [dash length, gap length]
      strokeWidth: 2, // optional, makes dashes clearer
    })
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Icing_binary_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      yAxis: yAxisSignal,
    })
    lineSeries.fills.template.setAll({
      fillOpacity: 0.3,
      visible: true,
    })
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4], // [dash length, gap length]
      strokeWidth: 2, // optional, makes dashes clearer
    })
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Icing_binary_physical_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      yAxis: yAxisSignal,
    })
    lineSeries.fills.template.setAll({
      fillOpacity: 0.3,
      visible: true,
    })
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4], // [dash length, gap length]
      strokeWidth: 2, // optional, makes dashes clearer
    })
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Icing_probability_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      yAxis: yAxisPercent,
    })
    lineSeries.strokes.template.setAll({
      strokeDasharray: [4, 4], // [dash length, gap length]
      strokeWidth: 2, // optional, makes dashes clearer
    })
    lineSeries
      .get('tooltip')
      .get('background')
      .setAll({ strokeDasharray: [4, 4] })
  } else if (seriesName === 'Windspeed_50') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0xc6d35a),
      stroke: am5.color(0xc6d35a),
      yAxis: yAxisWindspeed,
    })
  } else if (seriesName === 'Windspeed_online') {
    lineSeries = am5xy.LineSeries.new(root, {
      ...initObj,
      fill: am5.color(0x8edb7a),
      stroke: am5.color(0x8edb7a),
      yAxis: yAxisWindspeed,
    })
  }
  // else if (seriesName === 'Forecast_25') {
  //   lineSeries = am5xy.LineSeries.new(root, {
  //     ...initObj,
  //     name: '25th-50th percentile',
  //     valueYField: 'Forecast_50',
  //     valueXField: valueXField,
  //     openValueYField: 'Forecast_25',
  //   })
  //   lineSeries.strokes.template.set('strokeWidth', 0.1)
  //   lineSeries.fills.template.setAll({
  //     fillOpacity: 0.3,
  //     visible: true,
  //   })
  //   return lineSeries
  // }
  else {
    lineSeries = am5xy.LineSeries.new(root, initObj)
  }
  lineSeries.strokes.template.set('strokeWidth', 1.5)
  return lineSeries
}

const createSeriesFromData = (
  root,
  xAxis,
  yAxis,
  data,
  unit,
  resolution,
  yAxisSignal,
  yAxisPercent,
  yAxisWindspeed,
) => {
  const series = []

  if (data.length !== 0) {
    const seriesNames = Object.keys(data[0])
    seriesNames.forEach(name => {
      if (name !== TIMESTAMP) {
        const seriesName = name
        const valueYField = name

        let convertedData

        // Only convert units for non-flag, non-delta series!
        // Uncertainty_delta is shown through the plus/minus flag series
        if (seriesName === 'Uncertainty_delta') return

        if (seriesName === 'Uncertainty_flag') {
          // delta can exceed ±100 in theory; cap at 100%
          const pct = d =>
            d.Uncertainty_delta == null
              ? null
              : Math.min(Math.abs(d.Uncertainty_delta), 100)
          convertedData = data.map(d => ({
            ...d,
            Uncertainty_flag_plus: d.Uncertainty_flag === 1 ? pct(d) : 0,
            Uncertainty_flag_minus: d.Uncertainty_flag === -1 ? pct(d) : 0,
          }))

          // create PLUS series
          const plusSeries = createLineSeries(
            root,
            xAxis,
            yAxisPercent,
            'Uncertainty_flag_plus',
            'Uncertainty_flag_plus',
            yAxisSignal,
            yAxisPercent,
            yAxisWindspeed,
            unit,
          )
          plusSeries.data.setAll(convertedData)
          series.push(plusSeries)

          // create MINUS series
          const minusSeries = createLineSeries(
            root,
            xAxis,
            yAxisPercent,
            'Uncertainty_flag_minus',
            'Uncertainty_flag_minus',
            yAxisSignal,
            yAxisPercent,
            yAxisWindspeed,
            unit,
          )

          minusSeries.data.setAll(convertedData)
          series.push(minusSeries)

          // skip the “normal” series for Uncertainty_flag
          return
        } else if (
          seriesName === 'Icing_binary_50' ||
          seriesName === 'Icing_binary_physical_50' ||
          seriesName === 'Icing_probability_50' ||
          seriesName === 'Windspeed_50' ||
          seriesName === 'Windspeed_online' ||
          seriesName === 'Downregulation' ||
          seriesName === 'Downregulation_final'
        ) {
          // 0/1 binary signals: keep raw (no unit conversion).
          // For Downregulation series a missing value (null) means "off" (0).
          if (
            seriesName === 'Downregulation' ||
            seriesName === 'Downregulation_final'
          ) {
            convertedData = data.map(d => ({
              ...d,
              [seriesName]: d[seriesName] == null ? 0 : d[seriesName],
            }))
          } else {
            convertedData = data // Use raw data for these series
          }
        } else {
          convertedData = unitsConversion(unit, resolution, data, name)
        }
        const lineSeries = createLineSeries(
          root,
          xAxis,
          yAxis,
          seriesName,
          valueYField,
          yAxisSignal,
          yAxisPercent,
          yAxisWindspeed,
          unit,
        )

        lineSeries.data.setAll(convertedData)
        series.push(lineSeries)
      }
    })
  } else {
    console.error('Metrics data is empty.')
  }
  return series
}

const isSignalSeries = data => {
  if (!data || data.length === 0) return false
  const keys = Object.keys(data[0])
  const signalKeys = [
    'Icing_binary_50',
    'Icing_binary_physical_50',
    'Downregulation',
    'Downregulation_final',
  ]
  return signalKeys.some(k => keys.includes(k))
}

const isPercentSeries = data => {
  if (!data || data.length === 0) return false
  const keys = Object.keys(data[0])
  const percentKeys = ['Uncertainty_flag', 'Icing_probability_50']
  return percentKeys.some(k => keys.includes(k))
}

const isWindspeedSeries = data => {
  if (!data || data.length === 0) return false
  const keys = Object.keys(data[0])
  const percentKeys = ['Windspeed_50', 'Windspeed_online']
  return percentKeys.some(k => keys.includes(k))
}

const attachZeroSync = (root, refAxis, targetAxis, getVmax) => {
  if (!root || !refAxis || !targetAxis)
    return { recompute: () => {}, schedule: () => {} }

  const readVmax = () => {
    const v = typeof getVmax === 'function' ? getVmax() : getVmax
    return v != null && isFinite(v) && v > 0 ? v : 1
  }

  const getVisibleRange = axis => {
    const sMin = axis.getPrivate('selectionMin')
    const sMax = axis.getPrivate('selectionMax')
    const min = sMin != null ? sMin : axis.getPrivate('min')
    const max = sMax != null ? sMax : axis.getPrivate('max')
    return { min, max }
  }

  let scheduled = false
  const schedule = () => {
    if (scheduled) return
    scheduled = true

    root.events.on('frameended', function once() {
      root.events.off('frameended', once)
      scheduled = false
      recompute()
    })
  }

  const recompute = () => {
    const { min: refMin, max: refMax } = getVisibleRange(refAxis)
    if (refMin == null || refMax == null || refMin === refMax) return

    const VMAX = readVmax()

    // If 0 isn't even in visible range on the left, don't try to "align" it.
    if (refMin > 0 || refMax < 0) {
      targetAxis.setAll({
        min: 0,
        max: VMAX,
        strictMinMax: true,
        extraMin: 0,
        extraMax: 0,
      })
      targetAxis.markDirtyExtremes()
      targetAxis.markDirtyValues()
      return
    }

    // where is 0 on left, as a fraction of the axis height (0..1)
    const p0 = (0 - refMin) / (refMax - refMin)

    // pick target min so that target 0 is at same fraction
    const vmin = p0 <= 0 ? 0 : -(VMAX * p0) / (1 - p0)

    targetAxis.setAll({
      min: vmin,
      max: VMAX,
      strictMinMax: true,
      extraMin: 0,
      extraMax: 0,
    })

    targetAxis.markDirtyExtremes()
    targetAxis.markDirtyValues()
  }

  ;['min', 'max', 'selectionMin', 'selectionMax'].forEach(k => {
    refAxis.onPrivate(k, schedule)
  })
  targetAxis.events.on('boundschanged', schedule)

  return { recompute, schedule }
}

// vmax from ALL visible series that use a given axis
const getAxisVmaxFromSeries = (chart, axis) => {
  let vmax = 0
  chart.series.each(s => {
    if (s.get('yAxis') !== axis) return
    if (s.get('visible') === false) return
    if (s.get('ignoreMinMax')) return

    const di = s.get('dataItems')
    if (!di?.length) return

    di.forEach(item => {
      const v = item.get('valueY')
      if (v != null && isFinite(v)) vmax = Math.max(vmax, v)
    })
  })
  return vmax || 1
}

const getWindVmaxFromChartData = chartData => {
  let vmax = 0
  for (let i = 0; i < (chartData?.length || 0); i++) {
    const row = chartData[i]
    const v1 = row?.Windspeed_50
    const v2 = row?.Windspeed_online
    if (v1 != null && isFinite(v1)) vmax = Math.max(vmax, v1)
    if (v2 != null && isFinite(v2)) vmax = Math.max(vmax, v2)
  }
  return vmax || 1
}

function hideNegatives(axis) {
  if (!axis) return
  const r = axis.get('renderer')

  // Hide labels for negative tick values
  r.labels.template.adapters.add('text', (text, label) => {
    const v = label.dataItem?.get?.('value')
    return v != null && v < 0 ? '' : text
  })

  // Hide grid for negative tick values
  r.grid.template.adapters.add('visible', (visible, grid) => {
    const v = grid.dataItem?.get?.('value')
    return v != null && v < 0 ? false : visible
  })

  // Hide ticks for negative tick values (if present)
  r.ticks?.template.adapters.add('visible', (visible, tick) => {
    const v = tick.dataItem?.get?.('value')
    return v != null && v < 0 ? false : visible
  })
}

const addDailyTimeLines = (timezone, xAxis, startMs, endMs, issueTime) => {
  const hour = Math.floor(issueTime / 60)
  const minute = issueTime % 60

  let day = moment.tz(startMs, timezone).startOf('day')
  const endDay = moment.tz(endMs, timezone).startOf('day')

  while (day.isSameOrBefore(endDay)) {
    const ts = day
      .clone()
      .hour(hour)
      .minute(minute)
      .second(0)
      .millisecond(0)
      .valueOf()

    const range = xAxis.createAxisRange(xAxis.makeDataItem({ value: ts }))
    range.get('grid').setAll({ strokeOpacity: 0.35, strokeWidth: 0.5 })
    range.get('label').set('forceHidden', true)

    day.add(1, 'day')
  }
}

const MetricsTimeSeriesChart = props => {
  const classes = useStyles(props)
  const {
    chartDataRaw,
    chartName,
    selectedSetup,
    selectedPlant,
    selectedForecastType,
    latestUpdate,
    setTrackDisableStatus,
    resolution,
    issueTime,
    chartType,
  } = props
  const [chartIsReady, setChartIsReady] = useState(false)
  const containerRef = useRef(null)

  const timezone =
    loadStateFromLocalStorage('timezone') !== undefined
      ? loadStateFromLocalStorage('timezone')
      : 'Etc/UTC'

  const unit =
    loadStateFromLocalStorage('unit') !== undefined
      ? loadStateFromLocalStorage('unit')
      : 'kW'

  const chartData =
    chartType === 'metrics'
      ? chartDataRaw.map(item =>
          typeof item.Icing_power_loss_50 === 'number' &&
          typeof item.Forecast_50 === 'number'
            ? {
                ...item,
                Icing_power_loss_50: Number(
                  (item.Icing_power_loss_50 * item.Forecast_50).toFixed(3),
                ),
              }
            : item,
        )
      : chartDataRaw

  const latestUpdateFilePart =
    chartType === 'latest' && latestUpdate
      ? moment
          .tz(latestUpdate, 'YYYY-MM-DD HH:mm', 'UTC')
          .tz(timezone)
          .format('YYYYMMDD_HHmm')
      : null

  const exportFilePrefix = [
    selectedSetup,
    selectedPlant,
    selectedForecastType,
    latestUpdateFilePart,
    unit,
    chartType === 'latest' ? 'latest_timeseries' : 'metrics_timeseries',
  ]
    .filter(Boolean)
    .join('_')

  const chartTitle = [
    selectedPlant && `Plant: ${selectedPlant}`,
    selectedForecastType && `Horizon: ${selectedForecastType}`,
    ['ID', 'DAH'].includes(selectedForecastType) &&
      Number.isFinite(issueTime) &&
      `Issue time: ${formatMinutesAsTime(issueTime)} (${timezone})`,
  ]
    .filter(Boolean)
    .join('   |   ')

  useEffect(() => {
    const initializeChart = () => {
      try {
        if (typeof am5.registry.rootElements !== 'undefined') {
          am5.array.each(am5.registry.rootElements, function (root) {
            if (root && root.dom && root.dom.id === chartName) {
              root.dispose()
            }
          })
        }
        const root = am5.Root.new(chartName)
        /* Disable this in order to speed up chart because this adding some animation*/
        // root.setThemes([am5themes_Animated.new(root)])
        root._logo.dispose()
        root.timezone = am5.Timezone.new(timezone)

        const chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            panX: false,
            wheelY: 'zoomX',
            /* Disabling this option ensures that labels for all series will be shown on the chart.*/
            // maxTooltipDistance: 0,
            layout: root.verticalLayout,
          }),
        )

        if (chartTitle) {
          chart.children.unshift(
            am5.Label.new(root, {
              text: chartTitle,
              fontSize: 14,
              fontWeight: '300',
              textAlign: 'center',
              x: am5.percent(50),
              centerX: am5.percent(50),
              paddingBottom: 8,
            }),
          )
        }

        // Create power Y-axis
        const yAxis = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            marginRight: 20,
            extraTooltipPrecision: unit === 'MWh' || unit === 'MW' ? 1 : 0,
            renderer: am5xy.AxisRendererY.new(root, {}),
          }),
        )
        const powerLabel = am5.Label.new(root, {
          rotation: -90,
          text:
            unit === 'kW' || unit === 'MW'
              ? `Power (${unit})`
              : `Production (${unit})`,
          y: am5.p50,
          centerX: am5.p50,
        })
        yAxis.children.unshift(powerLabel)

        let yAxisSignal = null
        let yAxisPercent = null
        let yAxisWindspeed = null

        // Create Y-axis - signals
        if (isSignalSeries(chartData)) {
          yAxisSignal = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
              min: 0,
              max: 1,
              strictMinMax: true, // Ensures the axis doesn't auto-rescale
              maxPrecision: 0,
              renderer: am5xy.AxisRendererY.new(root, {
                opposite: true,
                minGridDistance: 30,
              }),
            }),
          )
          yAxisSignal.get('renderer').grid.template.setAll({
            strokeDasharray: [4, 4], // dashed
          })
          const signalLabel = am5.Label.new(root, {
            rotation: -90,
            // text: 'Text',
            y: am5.p50,
            centerX: am5.p50,
          })
          yAxisSignal.children.unshift(signalLabel)
          hideNegatives(yAxisSignal)
        }

        // Create Y-axis - precentage
        if (isPercentSeries(chartData)) {
          yAxisPercent = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
              min: 0,
              max: 100,
              strictMinMax: true,
              maxPrecision: 0, // No decimals for percent axis
              renderer: am5xy.AxisRendererY.new(root, {
                opposite: true,
                minGridDistance: 30,
              }),
              numberFormat: "#'%'",
            }),
          )
          yAxisPercent.get('renderer').grid.template.setAll({
            strokeDasharray: [4, 4], // dashed
          })
          hideNegatives(yAxisPercent)
        }

        // Create Y-axis - windspeed
        if (isWindspeedSeries(chartData)) {
          yAxisWindspeed = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
              min: 0,
              strictMinMax: false, // wind can scale up naturally
              renderer: am5xy.AxisRendererY.new(root, {
                opposite: true,
                minGridDistance: 30,
              }),
              numberFormat: '#', // plain number
            }),
          )

          yAxisWindspeed.get('renderer').grid.template.setAll({
            strokeDasharray: [4, 4],
          })
          const windLabel = am5.Label.new(root, {
            text: 'm/s',
            rotation: -90,
            centerX: am5.p50,
            y: am5.p50,
            x: am5.percent(100), // move to right side
            // dx: 20, // padding from axis
          })
          yAxisWindspeed.children.unshift(windLabel)

          hideNegatives(yAxisWindspeed)
        }

        // Create Y-axis - add extra space right
        const yExtraSpaceRight = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            maxPrecision: 0,
            syncWithAxis: yAxis,
            renderer: am5xy.AxisRendererY.new(root, {
              opposite: true,
            }),
          }),
        )
        yExtraSpaceRight.children.moveValue(
          am5.Label.new(root, {
            text: '',
            y: am5.p50,
            centerX: am5.p50,
          }),
          0,
        )

        // Create time X-Axis
        const xAxis = chart.xAxes.push(
          am5xy.DateAxis.new(root, {
            groupData: false,
            marginTop: 20,
            tooltipDateFormat: 'yyyy-MM-dd HH:mm',
            maxDeviation: 0.1,
            baseInterval: { timeUnit: 'minute', count: resolution },
            renderer: am5xy.AxisRendererX.new(root, {}),
          }),
        )
        const timeLabel = am5.Label.new(root, {
          text: timezone,
          x: am5.percent(50),
        })
        xAxis.children.push(timeLabel)
        xAxis.get('renderer').grid.template.setAll({
          strokeOpacity: 0,
        })
        xAxis.get('dateFormats')['month'] = 'yyyy-MM-dd'
        xAxis.get('dateFormats')['day'] = 'yyyy-MM-dd\nHH:mm'
        xAxis.get('dateFormats')['hour'] = 'yyyy-MM-dd\nHH:mm'
        xAxis.get('dateFormats')['minute'] = 'yyyy-MM-dd\nHH:mm'

        /** Add this to minimize tooltip distance from cursor axis */
        const r = xAxis.get('renderer')
        xAxis.set('tooltipLocation', 0)
        r.labels.template.setAll({ location: 0 })
        r.grid.template.setAll({ location: 0 })

        /** Add veritical lines for issue time */
        const startDate = chartData[0]?.Timestamp
        const endDate = chartData.at(-1)?.Timestamp

        if (startDate && endDate) {
          addDailyTimeLines(timezone, xAxis, startDate, endDate, issueTime)
        }

        const series = createSeriesFromData(
          root,
          xAxis,
          yAxis,
          chartData,
          unit,
          resolution,
          yAxisSignal,
          yAxisPercent,
          yAxisWindspeed,
        )
        series.forEach(lineSeries => {
          chart.series.push(lineSeries)
        })

        // Add scrollbarX with series data
        const scrollbarX = am5xy.XYChartScrollbar.new(root, {
          orientation: 'horizontal',
          height: 75,
        })
        chart.set('scrollbarX', scrollbarX)
        createSBSeriesFromData(root, scrollbarX, chartData)

        // Add cursor
        chart.set(
          'cursor',
          am5xy.XYCursor.new(root, {
            behavior: 'zoomXY',
            xAxis: xAxis,
            yAxis: yAxis,
          }),
        )

        xAxis.set(
          'tooltip',
          am5.Tooltip.new(root, {
            themeTags: ['axis'],
          }),
        )

        yAxis.set(
          'tooltip',
          am5.Tooltip.new(root, {
            themeTags: ['axis'],
          }),
        )

        if (yAxisPercent) {
          yAxisPercent.set(
            'tooltip',
            am5.Tooltip.new(root, {
              themeTags: ['axis'],
            }),
          )
        }

        if (yAxisWindspeed) {
          yAxisWindspeed.set(
            'tooltip',
            am5.Tooltip.new(root, {
              themeTags: ['axis'],
            }),
          )
        }

        // add legend
        const legend = chart.children.push(
          am5.Legend.new(root, {
            layout: root.gridLayout,
            centerX: am5.percent(50),
            x: am5.percent(50),
          }),
        )

        // hide specific series at the start
        chart.series.each(series => {
          if (hideOnBeggining.includes(series.get('name'))) {
            // mark as hidden
            series.set('visible', false)
            // also hide so legend syncs correctly
            series.hide(0) // pass 0 for no animation
          }
        })

        legend.data.setAll(chart.series.values)

        // --- ZERO ALIGN SYNC (left -> right) ---
        const syncSignal = yAxisSignal
          ? attachZeroSync(root, yAxis, yAxisSignal, () => {
              // signal is logically 0..1, so clamp to 1 even if data is < 1
              return Math.max(1, getAxisVmaxFromSeries(chart, yAxisSignal))
            })
          : { recompute: () => {}, schedule: () => {} }

        const syncPercent = yAxisPercent
          ? attachZeroSync(root, yAxis, yAxisPercent, () => {
              // percent is logically 0..100, so clamp to 100
              return Math.max(100, getAxisVmaxFromSeries(chart, yAxisPercent))
            })
          : { recompute: () => {}, schedule: () => {} }

        const syncWind = yAxisWindspeed
          ? attachZeroSync(root, yAxis, yAxisWindspeed, () =>
              Math.max(1, getWindVmaxFromChartData(chartData)),
            )
          : { recompute: () => {}, schedule: () => {} }

        // resync when zooming
        xAxis.events.on('rangechanged', () => {
          syncSignal.schedule()
          syncPercent.schedule()
          syncWind.schedule()
        })

        // resync when legend toggles / series hide/show
        chart.series.each(s => {
          s.on('hidden', () => {
            s.set('ignoreMinMax', true)
            syncSignal.schedule()
            syncPercent.schedule()
            syncWind.schedule()
          })
          s.on('shown', () => {
            s.set('ignoreMinMax', false)
            syncSignal.schedule()
            syncPercent.schedule()
            syncWind.schedule()
          })
          s.on('visible', v => {
            s.set('ignoreMinMax', !v)
            syncSignal.schedule()
            syncPercent.schedule()
            syncWind.schedule()
          })
        })

        // Force one run after first layout
        root.events.on('frameended', function once() {
          root.events.off('frameended', once)
          syncSignal.recompute()
          syncPercent.recompute()
          syncWind.recompute()
        })

        let menu = am5plugins_exporting.ExportingMenu.new(root, {})

        // TODO - enable when set new chartData. currently just work for one serie
        let exporting = am5plugins_exporting.Exporting.new(root, {
          menu: menu,
          pdfOptions: { disabled: true },
          pdfdataOptions: { disabled: true },
          jsonOptions: { disabled: true },
          htmlOptions: { disabled: true },
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          dataSource: unitsConversion(unit, resolution, chartData),
          filePrefix: exportFilePrefix,
          csvOptions: {
            separator: ';',
            addColumnNames: true,
            addBOM: true,
          },
        })

        exporting.events.on('dataprocessed', function (ev) {
          // add new when you found it
          const excludedColumns = [
            'AvailableTimeUTC (Availability)',
            'AvailableTimeUTC (Curtailment)',
          ]

          ev.data = ev.data.map(
            ({ Timestamp, Forecast_50, Online, Metering, ...rest }) => {
              Object.keys(rest).forEach(key => {
                if (excludedColumns.includes(key)) {
                  delete rest[key]
                }
              })
              Object.keys(rest).forEach(key => {
                if (rest[key] === null || rest[key] === undefined) {
                  rest[key] = ''
                }
              })
              return {
                [`Timestamp(${timezone})`]: moment
                  .utc(Timestamp)
                  .tz(timezone)
                  .format('YYYY-MM-DD HH:mm:ss'),
                Forecast_50: Forecast_50 ?? '',
                Online: Online ?? '',
                Metering: Metering ?? '',
                ...rest,
              }
            },
          )
        })

        // catch the event when chart is ready
        let timeout
        root.events.on('frameended', exportChart)
        function exportChart() {
          if (timeout) {
            clearTimeout(timeout)
          }
          timeout = setTimeout(function () {
            root.events.off('frameended', exportChart)
            setChartIsReady(true)
            setTrackDisableStatus(false)
          }, 100)
        }
      } catch (error) {
        console.error('Error in Metrics TimeSerise chart:', error)
      }
    }

    if (chartData && containerRef.current && !chartIsReady) {
      setTimeout(() => {
        initializeChart()
      }, 100)
    }
  }, [
    chartData,
    chartIsReady,
    chartName,
    chartTitle,
    exportFilePrefix,
    issueTime,
    resolution,
    setTrackDisableStatus,
    timezone,
    unit,
  ])

  return (
    <>
      {!chartIsReady && (
        <Box sx={{ width: '100%', marginTop: '400px' }}>
          <Typography
            variant="h4"
            className={clsx(classes.formSubtitle, classes.customSubtitle)}
          >
            Generating graph
          </Typography>
          <LinearProgress />
        </Box>
      )}
      <div
        ref={containerRef}
        id={chartName}
        style={{
          width: '100%',
          height: '750px',
          opacity: chartIsReady ? '1' : '0',
        }}
      ></div>
    </>
  )
}

export default MetricsTimeSeriesChart
